module.exports = __webpack_public_path__ + "media/luxury-2026/lake-architecture-drone-242f1be6.jpg";